import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, OnInit, Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { PurchasedProductInterface, RelationInterface } from 'outshared-lib';

/** @deprecated - insurances functionality is moved to libs/my-zone/insurances */
@Component({
    selector: 'ins-insurances',
    templateUrl: './insurances.component.html',
    styleUrls: ['./insurances.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InsurancesComponent {
    @Input() purchasedProducts: PurchasedProductInterface[];
    @Input() set total(value: number) {
        this.totalPrice = value.toFixed(2);
    }
    @Input() loading: boolean;
    @Input() relation: RelationInterface;

    public totalPrice: string;
    public isBrowser: boolean;

    constructor(@Inject(PLATFORM_ID) private platformId: object) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }
}
